import { Rate as AntRate } from 'antd';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Rate = styled(AntRate)`
  * {
    transition: none !important;
    transform: none !important;
  }
`;
